import * as React from 'react';
import Button from '../Button2';
import { Text } from '../Text';
import { Inline } from '../Inline';
import { useTranslation } from '@front10/utils';

interface Props {
  infoSlot?: React.ReactNode;
  actionsSlot?: React.ReactNode;
}

export function FilterFooter({ infoSlot, actionsSlot }: Props) {
  return (
    <Inline
      gap="36px"
      align={infoSlot ? 'space-between' : 'end'}
      alignY="center"
      as="footer"
      data-fr-footer
    >
      {infoSlot}
      <Inline gap="10px">{actionsSlot}</Inline>
    </Inline>
  );
}

export function ClearButton(props: React.ComponentPropsWithoutRef<typeof Button>) {
  const translate = useTranslation();
  return (
    <Button variant="text" {...props}>
      {translate('cmp-filter-footer-clear-button', 'Clear')}
    </Button>
  );
}

function ApplyButtonCmp(props: React.ComponentPropsWithoutRef<typeof Button>, ref: any) {
  const translate = useTranslation();
  return (
    <Button variant="primary" {...props} ref={ref}>
      {translate('cmp-filter-footer-apply-button', 'Apply')}
    </Button>
  );
}
export const ApplyButton = React.forwardRef(ApplyButtonCmp);

interface SummaryProps {
  count?: number | string;
}

export function Summary(props: SummaryProps) {
  const translate = useTranslation();
  return (
    <Text data-fr-output variant="fontSize10">
      <span data-fr-count>{props.count}</span>{' '}
      <span data-fr-label>{translate('cmp-filter-footer-selected-text', 'selected')}</span>
    </Text>
  );
}
